import a from 'indefinite';
import p from 'pluralize';

export const camelToSnakeCase = (str) =>
	str.replace(/[A-Z]/g, (letter, index) => (index === 0 ? letter.toLowerCase() : `_${letter.toLowerCase()}`));

export const indefinite = (word, options) => a(word, options);

/**
 * util to pluralize words
 * using npm package `pluralize`
 * https://www.npmjs.com/package/pluralize
 * @param {string} word - The word to pluralize
 * @param {number} count - How many of the word exist (default = 0)
 * @param {boolean} inclusive - Whether to prefix with the number (e.g. 3 ducks) (default = false)
 * @returns
 */
export const pluralize = (word, count = 0, inclusive = false) => p(word, count, inclusive);

/**
 * if possible, can use ::first-letter pseudo-element selector and text-transform css property
 * https://developer.mozilla.org/en-US/docs/Web/CSS/::first-letter
 *
 * we have a utility class (.first-letter-uppercase) that does it for you
 */
export const capitalizeWord = (word = '') => word.charAt(0).toUpperCase() + word.slice(1);

export const capitalizeFirstWord = (line = '') => {
	const words = line.split(' ');
	const firstWord = words[0];
	const capitalizedFirstWord = capitalizeWord(firstWord);
	return `${capitalizedFirstWord} ${words.slice(1).join(' ')}`;
};

export const capitalizeWordsInLine = (line = '') => {
	const words = line.split(' ');
	return words.map((word) => capitalizeWord(word)).join(' ');
};

export const shortenText = (text, shortBy) => {
	const description = text || '';
	const shortenedDescription = description.substring(0, shortBy);
	return shortenedDescription === description ? description : `${shortenedDescription}...`;
};
